import { render, staticRenderFns } from "./KPISetEdit.vue?vue&type=template&id=63237180"
import script from "./KPISetEdit.vue?vue&type=script&lang=js"
export * from "./KPISetEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports